import React, { useEffect, useState } from "react";
import "../../CSS/ItemMaster.css";
import axios from "axios";
import LoadingScreen from "../LoadingScreen";
import "jspdf-autotable";
import { FaArrowLeft } from "react-icons/fa";
import moment from "moment";
import { useSelector } from "react-redux";
import Select from "react-select";
import AllPagesNavbar from "../../Components/MasterNavbar/AllPagesMasterNavbar";

const WeighbridgeOut = () => {
  const BASEURL_GLOBAL = process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL = process.env.REACT_APP_BASEURL;
  const authToken = window.sessionStorage.getItem("auth-token");
  const sessionToken = window.sessionStorage.getItem("session-token");
  const [isloading, setisloading] = useState(true);
  const [search, setSearch] = useState("");
  const state = useSelector((state) => state.changeTheState.user);
  const user = state.emailId?.split("@")[0]?.toUpperCase();
  const [vehiclesList, setVehiclesList] = useState([]);
  const [showGateIn, setShowGateIn] = useState(false);
  const [date, setDate] = useState(new Date().toISOString());
  const [vehicleNo, setVehicleNo] = useState("");
  const [driver, setDriver] = useState("");
  const [driverCode, setDriverCode] = useState("");
  const [productsList, setProductsList] = useState([]);
  const [driversList, setDriversList] = useState([]);
  const [inwardNo, setInwardNo] = useState("");
  const [weight, setWeight] = useState("");
  const [emptyOrLoaded, setEmptyOrLoaded] = useState("");
  const [product, setProduct] = useState("");
  const [productCode, setProductCode] = useState("");
  const [weighinData, setWeighinData] = useState([]);
  const [weightOut, setWeightOut] = useState("");
  const [emptyOrLoadedOut, setEmptyOrLoadedOut] = useState("");
  const [dateout, setDateOut] = useState(new Date().toISOString());
  const [timeOut, setTimeOut] = useState(new Date().toLocaleTimeString());
  const [productOut, setProductOut] = useState("");
  const [productCodeOut, setProductCodeOut] = useState("");
  const [proceedToState, setProceedToState] = useState("");
  const [proceedToStateValue, setProceedToStateValue] = useState("");
  const [wbNo, setWbNo] = useState("");
  const [wbName, setWbName] = useState("");
  const [wbData, setWbData] = useState([]);
  const [clerkData, setClerkData] = useState([]);
  const [clerk, setClerk] = useState("");
  const [clerkCode, setClerkCode] = useState("");
  const [wbnoSearch, setWbnoSearch] = useState("");

  const [currentTime, setCurrentTime] = useState(
    new Date().toLocaleTimeString()
  );

  const VehicleDepartment = useSelector(
    (state) => state?.VehicleDepartmentReducer
  );

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeOut(new Date().toLocaleTimeString());
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const filteredData = weighinData.filter((item) => {
    const searchData = search.toLowerCase().split(" ").filter(Boolean);

    if (searchData.length === 0 && !wbnoSearch) {
      return true;
    }

    const textMatch = searchData.every((term) => {
      return ["WBTICKETNO", "TRUCKNO"].some((key) => {
        const columnValue = String(item[key]).toLowerCase();
        return columnValue.includes(term);
      });
    });

    const wbnoFilter = !wbnoSearch || item?.WEIGHBRIDGENAME === wbnoSearch;

    return textMatch && wbnoFilter;
  });

  useEffect(() => {
    initialData();
  }, []);

  const initialData = () => {
    //   Items List
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=625`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const filter = response?.data?.filter(
          (item) => item.OM_ITEM_FINISHED_RAW_MATERIAL === "F"
        );
        setProductsList(filter);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Item Details:", error);
      });

    // Driver's List  345;
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=345`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setDriversList(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Driver details:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1264`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        setWbData(response?.data);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Driver details:", error);
      });

    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=611`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const filteredData = response?.data?.filter(
          (item) => item?.DESIGNATION === "Weighbridge Clerk"
        );
        setClerkData(filteredData);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Clerk details:", error);
      });

    //   Saved weigh in data
    axios
      .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=1228`, {
        headers: {
          "auth-token": authToken,
          "session-token": sessionToken,
        },
      })
      .then((response) => {
        const filter = response?.data?.filter(
          (item) => item?.SECONDWEIGHT === null
        );
        setWeighinData(filter);
        setisloading(false);
      })
      .catch((error) => {
        setisloading(false);
        console.error("Error fetching Weigh in details:", error);
      });

    // axios
    //   .get(`${BASEURL_GLOBAL}/globalViewHandler?viewname=671`, {
    //     headers: {
    //       "auth-token": authToken,
    //       "session-token": sessionToken,
    //     },
    //   })
    //   .then((response) => {
    //     if (VehicleDepartment !== "") {
    //       const filterData = response?.data?.filter(
    //         (item) =>
    //           item.VEHICLESTATE === "SENT FOR WEIGHBRIDGE" &&
    //           item?.DEPARTMENT === VehicleDepartment
    //       );
    //       setVehiclesList(filterData);
    //     } else {
    //       const filterData = response?.data?.filter(
    //         (item) => item.VEHICLESTATE === "SENT FOR WEIGHBRIDGE"
    //       );
    //       setVehiclesList(filterData);
    //     }
    //     setisloading(false);
    //   })
    //   .catch((error) => {
    //     setisloading(false);
    //     console.error("Error fetching Charges details:", error);
    //   });
  };

  // Saving
  async function Save() {
    // if (!weightOut) {
    //   alert("Kindly Provide the Weight at departure");
    //   return;
    // }

    if (!wbName) {
      alert("Kindly Provide Weighbridge");
      return;
    }

    if (!clerk) {
      alert("Kindly Provide Weighbridge Clerk");
      return;
    }

    // if (emptyOrLoadedOut === "LOADED") {
    //   if (!productOut) {
    //     alert("Kindly Supply the Product at departure");
    //     return;
    //   }
    // }

    // if (emptyOrLoadedOut === "EMPTY") {
    //   if (Number(weight) <= Number(weightOut)) {
    //     alert(
    //       "Weight at departure can not be greater than Weight at Arrival as it is EMPTY"
    //     );
    //     return;
    //   }
    // }

    if (!proceedToState) {
      alert("Kindly Supply the State");
      return;
    }

    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1230`,
        {
          FIRSTSECOND: "SECOND",
          WBTICKETNO: Number(inwardNo),
          WBNUMBER: Number(wbNo),
          TRUCKNO: vehicleNo ? vehicleNo : "",
          DRIVERCODE: driverCode ? driverCode : "",
          CLERKCODE: clerkCode,
          // TRUCKEMPTYLOADEDONARRIVAL: emptyOrLoaded ? emptyOrLoaded : "",
          TRUCKEMPTYLOADEDONARRIVAL: "",
          // PRODUCTONARRIVAL: productCode ? productCode : "",
          PRODUCTONARRIVAL: "",
          // FIRSTWEIGHT: Number(weight),
          FIRSTWEIGHT: 0,
          FIRSTWEIGHTDATETIME: moment(date).format("YYYY/MM/DD"),
          // SECONDWEIGHT: Number(weightOut),
          SECONDWEIGHT: 0,
          SECONDWEIGHTDATETIME: moment(dateout).format("YYYY/MM/DD"),
          // TRUCKEMPTYLOADEDONDEPARTURE: emptyOrLoadedOut,
          TRUCKEMPTYLOADEDONDEPARTURE: "",
          // PRODUCTONDEPARTURE: productCodeOut,
          PRODUCTONDEPARTURE: "",
          CARGOWEIGHT: 0,
          MULTIPLEWEIGHBRIDGETOFOLLOW: 0,
          PREVIOUSWBTICKETNO: 0,
          VERICATIONNO: 0,
          WORKSHOPGATEPASSNO:0,
          // CARGOWEIGHT:
          //   Number(weight) > Number(weightOut)
          //     ? Number(weight) - Number(weightOut)
          //     : Number(weightOut) - Number(weight),
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        }
      );

      if (response.status === 201) {
        setisloading(false);
        alert(`Weighbridge Outward Updated successfully`);
        console.log(`Weighbridge Outward Updated successfully`);
        await SaveVehicleState();
        await SaveState();
        setShowGateIn(false);
        window.location.reload();
      } else {
        setisloading(false);
        console.error(`Error while saving Weighbridge Outward`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving Weighbridge Outward `, error);
    }
  }

  async function SaveVehicleState() {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1053`,
        {
          OT_VEHICLE_REG_NO: vehicleNo,
          OT_VEHICLE_STATE: proceedToStateValue,
          OT_VEHICLE_STATE_DATE: moment(dateout).format("YYYY/MM/DD"),
          OT_VEHICLE_STATE_TIME: timeOut,
          OT_VEHICLE_PREVIOUS_STATE: "SENT FOR WEIGHBRIDGE",
          OT_VEHICLE_STATE_UPDATED_BY: user,
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        }
      );

      if (response.status === 201) {
        setisloading(false);
        alert(`Vehicle State Updated successfully`);
        console.log(`Vehicle State Updated successfully`);
      } else {
        setisloading(false);
        console.error(`Error while saving Vehicle State`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving Vehicle State `, error);
    }
  }

  async function SaveState() {
    setisloading(true);
    try {
      const response = await axios.post(
        `${BASEURL_GLOBAL}/globalSpHandler?spname=1121`,
        {
          TRANSTYPE: proceedToStateValue,
          DOC_NO: Number(inwardNo),
        },
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessionToken,
          },
        }
      );

      if (response.status === 201) {
        setisloading(false);
        alert(`State Updated successfully`);
        console.log(`State Updated successfully`);
      } else {
        setisloading(false);
        console.error(`Error while saving State`);
      }
    } catch (error) {
      setisloading(false);
      console.error(`Error while saving State `, error);
    }
  }

  if (isloading) {
    return <LoadingScreen />;
  }

  return (
    <div className="min-h-screen">
      <AllPagesNavbar />
      <div className="flex justify-between">
        <h1 className="lg:text-3xl font-extrabold underline text-blue-600">
          Weighbridge Out
        </h1>
        <FaArrowLeft
          className="cursor-pointer hover:text-blue-300 transition-all"
          size={30}
          onClick={() => {
            window.history.back();
          }}
        />
      </div>

      <div className="select_product_type" style={{ marginTop: "5px" }}>
        <div>
          <p>Search</p>
        </div>
        <div>
          <input
            type="text"
            className="w-64 h-8 border border-black rounded-md"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          ></input>
        </div>

        <p className="text-red-600 lg:ml-2">Weighbridge :</p>
        <Select
          className="lg:w-64 lg:ml-2"
          menuPortalTarget={document.body}
          styles={{
            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
            menu: (base) => ({ ...base, zIndex: 9999 }),
          }}
          value={
            wbnoSearch
              ? { value: wbnoSearch, label: wbnoSearch }
              : { value: "", label: "Select" }
          }
          onChange={(e) => {
            setWbnoSearch(e.value);
          }}
          options={[
            { value: "", label: "Select" },
            ...weighinData?.map((item) => ({
              value: item?.WEIGHBRIDGENAME,
              label: item?.WEIGHBRIDGENAME,
            })),
          ]}
        ></Select>
      </div>

      <div className="visible lg:h-[500px] p-1 z-0 lg:overflow-auto mt-2">
        <table className="w-full border border-gray-300 text-sm">
          <thead className="sticky top-0">
            <tr className="bg-[#2b3f5c] text-white text-[12px]">
              <td className="py-2 px-4 text-right border border-gray-300">
                SNO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                WEIGHBRIDGE
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                VEHICLE REG NO
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                DRIVER NAME
              </td>
              {/* <td className="py-2 px-4 text-left border border-gray-300">
                EMPTY/LOADED
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                PRODUCT ON ARRIVAL
              </td>
              <td className="py-2 px-4 text-left border border-gray-300">
                WEIGHT AT ARRIVAL
              </td> */}
              <td className="py-2 px-4 text-left border border-gray-300">
                WEIGHBRIDGE IN DATE
              </td>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((value, index) => {
              const dri = driversList?.find(
                (item) => item?.DRIVERCODE === value?.DRIVERCODE
              );
              const prod = productsList?.find(
                (item) => item?.ITEMCODE === value?.PRODUCTONARRIVAL
              );

              return (
                <tr
                  key={index}
                  className="hover:bg-gray-100 cursor-pointer text-[13px]"
                  onClick={() => {
                    const dri = driversList?.find(
                      (item) => item?.DRIVERCODE === value?.DRIVERCODE
                    );
                    setDriver(dri?.DRIVERNAME);
                    setDriverCode(value?.DRIVERCODE);
                    setVehicleNo(value["TRUCKNO"]);
                    setInwardNo(value?.WBTICKETNO);
                    // setEmptyOrLoaded(value?.TRUCKEMPTYLOADEDONARRIVAL);
                    // setEmptyOrLoadedOut(
                    //   value?.TRUCKEMPTYLOADEDONARRIVAL === "EMPTY"
                    //     ? "LOADED"
                    //     : "EMPTY"
                    // );
                    // setWeight(value?.FIRSTWEIGHT);
                    setDate(value?.FIRSTWEIGHTDATETIME);
                    const prod = productsList?.find(
                      (item) => item?.ITEMCODE === value?.PRODUCTONARRIVAL
                    );
                    setWbName(value?.WEIGHBRIDGENAME)
                    setWbNo(value?.WEIGHBRIDGENUMBER)
                    const clerk = clerkData?.find((item) => item?.["EMPLOYEE CODE"] === value?.WEIGHBRIDGECLERK)
                    setClerk(clerk?.["EMPLOYEE NAME"])
                    setClerkCode(value?.WEIGHBRIDGECLERK)
                    // 
                    // setProduct(prod?.ITEMDESCRIPTION);
                    // setProductCode(value?.PRODUCTONARRIVAL);
                    setShowGateIn(true);
                  }}
                >
                  <td className="py-2 px-4 text-right border border-gray-300">
                    {index + 1}
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    {value["WEIGHBRIDGENAME"] || "N/A"}
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    {value["TRUCKNO"] || "N/A"}
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    {dri?.DRIVERNAME || "N/A"}
                  </td>
                  {/* <td className="py-2 px-4 text-left border border-gray-300">
                    {value["TRUCKEMPTYLOADEDONARRIVAL"] || "N/A"}
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    {prod?.ITEMDESCRIPTION || "N/A"}
                  </td>
                  <td className="py-2 px-4 text-left border border-gray-300">
                    {value.FIRSTWEIGHT || "N/A"}
                  </td> */}
                  <td className="py-2 px-4 text-left border border-gray-300">
                    {value["FIRSTWEIGHTDATETIME"]
                      ? moment(value["FIRSTWEIGHTDATETIME"]).format(
                          "DD/MM/YYYY"
                        )
                      : "N/A"}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/* PopUp */}
      {showGateIn && (
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-[100] bg-white border border-black lg:h-[300px] h-[80%] lg:w-[900px] w-[95%] p-1 overflow-y-auto rounded-md">
          <h1 className="text-3xl font-bold flex lg:justify-center justify-start">
            WEIGHBRIDGE OUT
          </h1>
          {/* Row 1 */}
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Inward No:</p>
            <input
              className="w-20 text-right h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={inwardNo}
              readOnly
            ></input>

            <p className="text-red-600 lg:ml-20">Date at arrival :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="date"
              value={date?.split("T")[0]}
              readOnly
            ></input>

            <p className="text-red-600 lg:ml-20">Time at arrival :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={currentTime}
              readOnly
            ></input>
          </div>
          {/* Row 2 */}
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2 mr-1">Vehicle :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-6 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={vehicleNo}
              readOnly
            ></input>
            <p className="text-red-600 lg:ml-8 mr-1">Driver :</p>
            <input
              className="w-52 h-8 border border-black lg:ml-14 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={driver}
              readOnly
            ></input>
            {/* <p className="text-red-600 lg:ml-2">Weight at arrival:</p>
            <input
              className="w-24 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="number"
              value={weight}
              readOnly
            ></input> */}
          </div>
          {/* Row 3 */}
          {/* <div className="lg:flex lg:flex-row mt-2"> */}
          {/* <p className="text-red-600 lg:ml-2 mr-1">Product at arrival:</p>
            <input
              className="w-56 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={product}
              readOnly
            ></input> */}

          {/* <p className="text-red-600 lg:ml-2 mr-1">
              Empty/Loaded at arrival :
            </p>
            <input
              className="w-56 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={emptyOrLoaded}
              readOnly
            ></input> */}
          {/* </div> */}
          {/* Row 4  */}
          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2">Date Out :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="date"
              value={dateout?.split("T")[0]}
              readOnly
            ></input>

            <p className="text-red-600 lg:ml-9">Time Out :</p>
            <input
              className="w-32 h-8 border border-black lg:ml-10 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={timeOut}
              readOnly
            ></input>

            <p className="text-red-600 lg:ml-6">Weighbridge :</p>

             <input
              className="w-64 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={wbName}
              readOnly
            ></input>

            {/* <Select
              className="lg:w-64 w-64 lg:ml-2"
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
              }}
              value={
                wbName
                  ? { value: wbName, label: wbName }
                  : { value: "", label: "Select Weighbridge" }
              }
              onChange={(e) => {
                setWbName(e.label);
                setWbNo(e.value);
              }}
              options={[
                { value: "", label: "Select Product" },
                ...wbData?.map((item) => ({
                  value: item.WBNUMBER,
                  label: item.WBNAME,
                })),
              ]}
            ></Select> */}

            {/* <p className="text-red-600 lg:ml-6">Weight at departure:</p>
            <input
              className="w-24 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="number"
              value={weightOut}
              onChange={(e) => setWeightOut(e.target.value)}
            ></input> */}
          </div>
          {/* Row 5  */}
          {/* <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2 mr-1">Product at Departure :</p>
            <Select
              className="lg:w-56 w-64 lg:ml-2"
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
              }}
              value={
                productOut
                  ? { value: productOut, label: productOut }
                  : { value: "", label: "Select Product" }
              }
              onChange={(e) => {
                setProductOut(e.label);
                setProductCodeOut(e.value);
              }}
              options={[
                { value: "", label: "Select Product" },
                ...productsList?.map((item) => ({
                  value: item.ITEMCODE,
                  label: item.ITEMDESCRIPTION,
                })),
              ]}
            ></Select>

            <p className="text-red-600 lg:ml-2 mr-1">
              Empty/Loaded at Departure:
            </p>
            <input
              className="w-56 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={emptyOrLoadedOut}
              readOnly
            ></input>
          </div> */}

          <div className="lg:flex lg:flex-row mt-2">
            <p className="text-red-600 lg:ml-2 mr-1">Weighbridge Clerk :</p>
             <input
              className="w-64 h-8 border border-black lg:ml-2 p-2 rounded-md focus:outline-none focus:border-blue-500"
              type="text"
              value={clerk}
              readOnly
            ></input>
            {/* <Select
              className="lg:w-64 w-64 lg:ml-2"
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 }),
              }}
              value={
                clerk
                  ? { value: clerk, label: clerk }
                  : { value: "", label: "Select Weighbridge Clerk" }
              }
              onChange={(e) => {
                setClerk(e.label);
                setClerkCode(e.value);
              }}
              options={[
                { value: "", label: "Select Weighbridge Clerk" },
                ...clerkData?.map((item) => ({
                  value: item["EMPLOYEE CODE"],
                  label: item["EMPLOYEE NAME"],
                })),
              ]}
            ></Select> */}

            <p className="text-red-600 lg:ml-12">Proceed To :</p>
            <Select
              className="lg:w-80 lg:ml-2"
              menuPortalTarget={document.body} // ⬅️ Renders dropdown at body level
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }), // ⬅️ Forces on top
              }}
              value={
                proceedToState
                  ? { value: proceedToState, label: proceedToState }
                  : { value: "", label: "Select State" }
              }
              onChange={(e) => {
                setProceedToState(e.label);
                setProceedToStateValue(e.value);
              }}
              options={[
                { value: "", label: "Select State" },
                { value: "SENT TO WORKSHOP", label: "PROCEED TO WORKSHOP" },
                { value: "SENT TO LOAD", label: "PROCEED TO LOAD" },
              ]}
            ></Select>
          </div>
          <div className="flex justify-center mt-5">
            <button
              className="lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
              onClick={async () => {
                await Save();
              }}
            >
              WEIGH OUT
            </button>
          </div>
          <button
            className="absolute top-2 right-2 lg:flex items-center justify-center border border-black bg-[#002d62] text-white rounded-md px-3 py-1 lg:ml-2 mr-2    focus:outline-none focus:ring focus:border-blue-300"
            onClick={() => setShowGateIn(false)}
          >
            Close
          </button>
        </div>
      )}
    </div>
  );
};

export default WeighbridgeOut;
